export default __webpack_public_path__ + "static/media/home.02004f4f.png";